import styled from '@emotion/styled';
import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { __snackBarSeverity, __snackBarText } from '../../constants';
import mainContext from '../../contexts/mainContext';
import { addCityController, getCitiesListing, getCountriesListingController } from '../../Controllers/ScopeManagement';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { Edit } from '@mui/icons-material';

function FormDialog({ open, handleClose, handleAddUpdate, cityInfo = {} }) {
    const [countries, setCountries] = React.useState([]);
    const [state, setState] = useState({
        _id: cityInfo?._id || null,
        countryId: cityInfo?.countryId,
        city: cityInfo?.city,
        timezone: cityInfo?.timezone ? cityInfo?.timezone.replace("GMT", "") : null
    })

    const getCountriesList = async () => {
        const res = await getCountriesListingController();
        setCountries(res.data.data.countryList)
    }

    React.useEffect(() => {
        getCountriesList();
    }, [])

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{state?._id ? "Update " : "Add new "} city</DialogTitle>
                <DialogContent>
                    <div>
                        <InputLabel id="country" sx={{ margin: '0', padding: "0" }}>Country</InputLabel>
                        <Select
                            autoFocus
                            variant="standard"
                            sx={{ width: "100%" }}
                            labelId="country"
                            label="Country"
                            multiple={false}
                            defaultValue={state.countryId}
                            onChange={(e) => { setState({ ...state, countryId: e.target.value }) }}
                        >
                            {countries.map((e) => (
                                <MenuItem value={e._id}>{e.name}</MenuItem>
                            ))}
                        </Select>
                        {/* </FormControl> */}
                    </div>
                    <TextField
                        margin="dense"
                        id="city"
                        label="City name"
                        type="text"
                        fullWidth
                        variant="standard"
                        defaultValue={state.city}
                        onChange={(e) => { setState({ ...state, city: e.target.value }) }}
                    />
                    <TextField
                        placeholder='+05:30'
                        margin="dense"
                        id="timezone"
                        label="Timezone"
                        type="text"
                        fullWidth
                        variant="standard"
                        defaultValue={state.timezone}
                        onChange={(e) => { setState({ ...state, timezone: e.target.value }) }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} size="small" >Cancel</Button>
                    <Button onClick={() => { handleAddUpdate(state) }} variant="contained" size="small" >{state?._id ? "Update" : "Add"}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
const Cities = () => {
    const { setSnackBar, setProfileNavTitle, setPageload } = React.useContext(mainContext);
    const [open, setOpen] = React.useState(false);
    const [cities, setCities] = React.useState([]);
    const [cityInfo, setCityInfo] = React.useState({
        countryId: null,
        city: null,
        timezone: null
    });
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCityInfo({
            ...cityInfo,
            _id: null,
            countryId: null,
            city: null,
            timezone: null
        })
    };


    const handleAddUpdate = async (updatedState) => {
        let { countryId, city, timezone, _id = null } = updatedState

        if (countryId === "" || city === "") {
            return setSnackBar({
                status: true,
                text: "Country/City are required.",
                severity: __snackBarSeverity.error
            })
        }
        else if (city.toString().trim() === "") {
            return setSnackBar({
                status: true,
                text: "Please enter city name",
                severity: __snackBarSeverity.error
            })
        }
        else if (!timezone) {
            return setSnackBar({
                status: true,
                text: "Please enter city timezone",
                severity: __snackBarSeverity.error
            })
        }
        else {
            const reg = new RegExp(/^[a-zA-Z ,.-]*$/gi)
            const res = reg.test(city.replace(/\n/g, " "));
            if (!res) {
                return setSnackBar({
                    status: true,
                    text: "Please enter valid city name.",
                    severity: __snackBarSeverity.error
                })
            }
        }
        let regForTimezone = /^(?:Z|[+-](?:2[0-3]|[01][0-9]):[0-5][0-9])$/
        if (!regForTimezone.test(timezone)) {
            return setSnackBar({
                status: true,
                text: "Please enter valid timezone format.",
                severity: __snackBarSeverity.error
            })
        }
        let tmpTimezone = "GMT" + timezone
        let config = { ...updatedState }
        config.timezone = tmpTimezone
        setPageload(true)
        const res = await addCityController(config);
        setPageload(false)
        if (res && res.data.status === 200) {
            // Show success message based on operation type
            setSnackBar({
                status: true,
                text: _id ? "City updated successfully" : "City added successfully",
                severity: __snackBarSeverity.success
            });
            
            // Reset form state
            setCityInfo({
                _id: null,
                countryId: null,
                city: null,
                timezone: null
            });
            
            // Close dialog
            setOpen(false);
            
            // Refresh the entire list from server to ensure consistency
            getCities();
            
        } else if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message,
                severity: __snackBarSeverity.error
            });
        }
}
    const getCities = async () => {
        setPageload(true)
        const res = await getCitiesListing();
        setPageload(false)
        if (res && res.status === 500) {
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            return setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.error
            });
        }
        if (res.data.data.length === 0) {
            return setSnackBar({
                status: true,
                text: __snackBarText.noDataFound,
                severity: __snackBarSeverity.info
            });
        }
        setCities(res.data.data);
    }

    React.useEffect(() => {
        getCities();
        setProfileNavTitle("Available Cities");
        // eslint-disable-next-line
    }, [])

    const handleEdit = (item) => {
        setCityInfo({
            ...cityInfo,
            _id: item._id,
            countryId: item.countryId,
            city: item.city,
            timezone: item.timezone
        })
        setOpen(true)
    }



    return (
        <>
            {open && <FormDialog cityInfo={cityInfo} open={open} handleClose={handleClose} handleAddUpdate={handleAddUpdate} />}
            <Conatiner>
                <Header>
                    <Button variant="contained" size='small' onClick={handleClickOpen}>Add new</Button>
                </Header>
                <Body>
                    <List>
                        <div className="header">Cities</div>
                        <div className="header">Timezone</div>
                        <div></div>
                    </List>
                    <Divider className='divider-gap' />
                    {
                        cities.map((item) => {
                            return (
                                <List key={item._id}>
                                    <div>
                                        {item.city}
                                    </div>
                                    <div>
                                        {item?.timezone || "..."}
                                    </div>
                                    <div style={{ textAlign: "right" }}>

                                        <Edit className='pointer' sx={{ marginRight: 2 }} onClick={() => handleEdit(item)} />
                                    </div>
                                </List>
                            )
                        })
                    }
                </Body>
            </Conatiner>
        </>
    )
}

const Conatiner = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
`;

const Header = styled("div")`
  button{
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  height: 80vh;
`;

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 2fr 6fr 1fr;
`;

export default Cities